module.exports = __webpack_public_path__ + "img/add-more-member-licence.e55cb9a5.png";